import { contactData, privateAddressData } from '../data/contactData';
import { FaMapMarkerAlt, FaEnvelope, FaPhone, FaUser } from 'react-icons/fa';
import PageWrapper from "../components/PageWrapper";

const iconMap = {
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhone,
  FaUser,
};

const InfoRow = ({ icon, children }) => {
  const IconComponent = iconMap[icon];
  return (
    <div className="flex items-start space-x-4 mb-6">
      <div className="p-3 bg-sky-100 rounded-xl" aria-hidden="true">
        {IconComponent && <IconComponent className="text-sky-600 text-md" />}
      </div>
      <div className="text-md font-medium text-gray-500 font-body">{children}</div>
    </div>
  );
};

const LocationSection = ({ data, mapEmbed }) => (
  <section className="mt-12 mx-auto max-w-6xl px-6 lg:px-8 p-8 rounded-xl border shadow-xl bg-white" aria-labelledby={`section-${data.address.title.replace(/\s/g, '-')}`}>
    <div className="grid grid-cols-1 md:grid-cols-10 gap-8 items-start">
      {/* Left Column */}
      <div className="md:col-span-3 space-y-4">
        <header>
          <h2 id={`section-${data.address.title.replace(/\s/g, '-')}`} className="text-xl font-semibold tracking-tight text-gray-950 font-heading">
            {data.address.title}
          </h2>
        </header>
        <address className="not-italic">
          <InfoRow icon={data.address.icon}>
            <p>{data.address.street}</p>
            <p>{data.address.city}</p>
          </InfoRow>
          {data.phone && (
            <InfoRow icon={data.phone.icon}>
              <a href={`tel:${data.phone.number}`} className="hover:text-sky-600 font-body">
                {data.phone.number}
              </a>
            </InfoRow>
          )}
          {data.email && (
            <InfoRow icon={data.email.icon}>
              <a
                href={`mailto:${data.email.address}`}
                className="hover:text-sky-600 font-body"
              >
                {data.email.address}
              </a>
            </InfoRow>
          )}
        </address>
      </div>
      {/* Right Column - Google Map */}
      <div className="md:col-span-7 w-full h-40 md:h-80 rounded-xl overflow-hidden">
        <iframe
          title={`Karte: ${data.address.title}`}
          className="w-full h-full"
          src={mapEmbed}
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  </section>
);

const Contact = () => {
  return (
    <PageWrapper>
      <main>
        <section
          className="py-12 sm:py-16 min-h-screen"
          style={{
            backgroundImage: `url('/gradient_bg.svg'), linear-gradient(to bottom, #0ea5e9, #ffffff 50%, #ffffff)`,
            backgroundRepeat: "no-repeat, no-repeat",
            backgroundSize: "cover, cover",
            backgroundPosition: "center, center",
          }}
          aria-labelledby="contact-heading"
        >
          <div className="mx-auto max-w-6xl px-2 sm:px-6 lg:px-8">
            <header className="mx-auto max-w-6xl px-2 sm:px-6 lg:px-8">
              <h1 id="contact-heading" className="text-center text-base font-semibold text-sky-600 font-heading">
                {contactData.title}
              </h1>
              <p className="mx-auto mt-2 max-w-lg text-center text-2xl font-semibold tracking-tight text-gray-950 font-heading">
                {contactData.subtitle}
              </p>
            </header>
            {/* Sections */}
            <LocationSection
              data={privateAddressData}
              mapEmbed="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11808.212603304486!2d13.453703!3d52.526483!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47a84e6feab86add%3A0xfd8ddc1186b93e5c!2sHausburgstra%C3%9Fe%2013%2C%2010249%20Berlin!5e1!3m2!1sde!2sde!4v1743258280362!5m2!1sde!2sde&maptype=satellite"
            />
            <LocationSection
              data={contactData}
              mapEmbed="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11845.01738032317!2d13.700938!3d52.389456!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47a8398f97a8fac7%3A0xdeaaae5c47e28256!2sEichwalder%20Ausbau%2C%2015537%20Gosen-Neu%20Zittau-Gosen!5e1!3m2!1sde!2sde!4v1743255095332!5m2!1sde!2sde&maptype=roadmap"
            />
          </div>
        </section>
      </main>
    </PageWrapper>
  );
};

export default Contact;